import { get, includes } from 'lodash';
import { getStore } from '../../configureStore';
import { catchError } from '../../modules/App/redux/catchErrorRequest/actions';

const unavailableErrorsCodes = [403, 503, 509];

export const backendUnavailableInterceptor = () => (error) => {
  const errorCode = get(error, 'response.status');
  if (includes(unavailableErrorsCodes, errorCode)) {
    getStore().dispatch(catchError({ errorCode }));
  }
  return Promise.reject(error);
};
